// 安装管理API
import request from '@/utils/request'

/**
 * 根据项目pid查询指定的安装工单
 * @param pid
 * @returns {*}
 */
export function getInstall(pid) {
    return request({
        url: '/project/install/'+pid,
        method: 'get'
    })
}

/**
 * 根据id更新安装单信息
 * @param data
 * @returns {*}
 */
export function updateInstall(data) {
    return request({
        url: '/project/install',
        method: 'put',
        data
    })
}

/**
 * 根据条件获取安装工单的分页
 * @param params
 * @param data
 * @returns {*}
 */
export function installPage(params,data){
    return request({
        url: '/project/install/page',
        method: 'post',
        data,
        params
    })
}
